import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAX4hxWJB_0A7YHR0wXN5VoUxxh0CdLLjQ",
  authDomain: "newton-books.firebaseapp.com",
  databaseURL: "https://newton-books.firebaseio.com",
  projectId: "newton-books",
  storageBucket: "newton-books.appspot.com",
  messagingSenderId: "721290858920",
  appId: "1:721290858920:web:988aaea9a11c4be83ccd9d"
};

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const functions = firebase.functions();
const storage = firebase.storage();

// db.enablePersistence()
//   .catch(err => {
//     if (err.code == 'failed-precondition') {
//       // Multiple tabs open, persistence can only be enabled
//       // in one tab at a time
//       console.log('persistence failed, probably multiple tabs open at once.');
//     } else if (err.code = 'unimplemented') {
//       // lack of browser suppport
//       console.log('persistence is not available.');
//     }
//   });

export {
  auth,
  db,
  functions,
  storage
}